/* eslint-disable global-require */
const sfx = { hub_logout_sfx: require('./hub_logout_sfx.mp3') };

export default sfx;
